export default __webpack_public_path__ + "static/security-tfa-379cc6a5cbf75cd69171b1c972910b5a.svg";